import EntrprisesList from './EntrprisesList.page';

export default EntrprisesList;
